The input parameter for the `updatePositionOpeningStatus` mutation.
